import ScheduleSubtitle from './ScheduleSubtitle';

export default ScheduleSubtitle;
